module.exports = __webpack_public_path__ + "cli-demo.svg";